module.exports = __webpack_public_path__ + "img/icon-content-improvements.d6a549a2.svg";